import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import ValidatedSelect from '../../common/forms/ValidatedSelect';
import { FormContext } from '../../common/forms/FormElements';

export const Contract = () => {
    const { values, setFieldValue } = useContext(FormContext);
    const { companyId, dispatchLocationId } = values;

    const { data, isLoading } = useQuery({
        queryKey: ['quickRentalContractsForCustomer', companyId, dispatchLocationId],
        queryFn: () => httpClient.js(
            ApiRoutes.typeAheads.quickRentalContractsForCustomer(companyId, dispatchLocationId),
        ),
        enabled: !!(companyId && dispatchLocationId),
    });

    return (
        <ValidatedSelect
            id="contractId"
            name="contractId"
            label="Quick Rental Contract"
            options={data}
            isLoading={isLoading}
            isDisabled={!companyId}
            required
            error="A contract is required."
            onChange={() => setFieldValue('projectId', null)}
        />
    );
};
